module.exports = __webpack_public_path__ + "static/img/y-2024.501b5d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/y-2024.jpg
// module id = HoL5
// module chunks = 0